import React, {useEffect, useRef} from 'react';
import {CheckCircle2, X} from 'lucide-react';
import {useLocation, useNavigate} from 'react-router-dom';
import {isUpgradeReason} from './conversionPrompts';

export default function UpgradeReturnNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const noticeRef = useRef(null);
  const params = new URLSearchParams(location.search || '');
  const state = params.get('upgradeReturn');
  const reason = isUpgradeReason(params.get('upgradeReason')) ? params.get('upgradeReason') : '';
  const visible = state === 'activated' || state === 'cancelled';

  useEffect(() => {
    if (!visible) return;
    noticeRef.current?.focus?.({preventScroll: true});
  }, [location.pathname, state, visible]);

  if (!visible) return null;

  const dismiss = () => {
    const next = new URLSearchParams(location.search || '');
    next.delete('upgradeReturn');
    next.delete('upgradeReason');
    navigate(`${location.pathname}${next.toString() ? `?${next.toString()}` : ''}${location.hash || ''}`, {
      replace: true,
    });
  };

  return (
    <div className="border-b border-emerald-200 bg-emerald-50 px-4 py-3" role="status" aria-live="polite">
      <div
        ref={noticeRef}
        tabIndex={-1}
        className="mx-auto flex max-w-[1200px] items-start justify-between gap-3 outline-none"
      >
        <div className="flex min-w-0 items-start gap-2 text-sm text-emerald-950">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <div>
            <p className="font-semibold">
              {state === 'activated'
                ? 'Company is active. Continue where you left off.'
                : reason === 'ai_followup_limit'
                  ? 'No changes were made. Your Scenario is safe.'
                  : 'No changes were made. Your work is safe.'}
            </p>
            {state === 'cancelled' ? (
              <p className="mt-0.5 text-emerald-900">Your current plan and existing work are unchanged.</p>
            ) : null}
          </div>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-emerald-800 hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-offset-2"
          aria-label="Dismiss plan update notice"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
